import { render } from "./contributing.md?vue&type=template&id=4acb1847"
import script from "./contributing.md?vue&type=script&lang=js"
export * from "./contributing.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__